import { ExternalUrlAdminTranslation } from 'app/area/external-urls-administration/constants';
import { ComplexValue, ValidationLevel, ValidationMessage } from 'ui';
import { languageValidationParameter } from '../constants';
import { ExternalUrlItem, ExternalUrlItemValidation } from '../types-store';
import { ExternalUrlFormIds } from 'app/area/external-urls-administration/form/constants';
import { ExternalUrlActionType } from 'app/area/external-urls-administration/form/types';

const validationMessageHelper = (propName: string, messages: ValidationMessage | ValidationMessage[]) => {
  return {
    [propName]: {
      level: ValidationLevel.error,
      messages
    }
  };
};

export const validateExternalUrl = (
  actionType: ExternalUrlActionType,
  externalUrl: ExternalUrlItem,
  languageOptions: ComplexValue<number>[],
  translation: ExternalUrlAdminTranslation
): ExternalUrlItemValidation => {

  const defaultValidationError = {
    level: ValidationLevel.error,
    message: translation.must_be_filled_out
  };

  const allLanguages = (languageOptions || [])
    .map(option => (externalUrl && externalUrl.language || [])
      .find(language => language.value === option.value)
      || { value: option.value }
    );

  const languageValidation = allLanguages
    .map(language =>
      language.description === undefined || language.description.trim() === ''
        ? {
          ...defaultValidationError,
          parameters: {
            [languageValidationParameter]: language.value
          }
        } as ValidationMessage
        : undefined
    )
    .filter(validation => !!validation);

  const importExternalUrlTemplateValidation = !externalUrl?.urlTemplate
    ? defaultValidationError
    : undefined;

  return {
    ...(languageValidation.length > 0 && validationMessageHelper(ExternalUrlFormIds.language, languageValidation)),
    ...(!!importExternalUrlTemplateValidation
      && validationMessageHelper(ExternalUrlFormIds.urlTemplate, [importExternalUrlTemplateValidation]))
  };
};
